export enum SubscriptionType {
  Offer = 'offer',
  Filter = 'filter',
}
